module.exports = __webpack_public_path__ + "assets/img/19_862.88455447.jpg";